import { Box, Paper, useComputedColorScheme } from '@mantine/core';
import { useDevice } from '@zala-team/ui-web';
import { useLanding } from '#website/layouts/Landing.context.ts';
import { HeaderSimple } from './HeaderSimple';

const Header = () => {
	const { columnWidth, menuOpened, toggleMenu, closeMenu, headerPinned, isFloatingHeaderPinnedDisabled } = useLanding();
	const { isMobile } = useDevice();
	const computedColorScheme = useComputedColorScheme();

	return (
		<>
			<Paper
				maw={isMobile ? columnWidth : columnWidth + 40}
				m={'auto'}
				bg={'var(--website-color-paper)'}
				withBorder={computedColorScheme === 'dark'}
				style={{
					position: 'fixed',
					top: 10,
					left: 0,
					right: 0,
					borderColor: 'var(--website-color-border)',
					zIndex: 1000000,
					transform: `translate3d(0, ${!headerPinned && !menuOpened && !isFloatingHeaderPinnedDisabled ? 0 : '-110px'}, 0)`,
					transition: 'transform 400ms ease',
				}}
				shadow='lg'
				radius='xl'
				p='xs'
				pr={'sm'}
				pl={'md'}
			>
				<HeaderSimple menuOpened={menuOpened} menuClose={closeMenu} menuToggle={toggleMenu} sticky={true} />
			</Paper>
			<Box p={'sm'} mt={'md'} m={'auto'}>
				<HeaderSimple menuOpened={menuOpened} menuClose={closeMenu} menuToggle={toggleMenu} />
			</Box>
		</>
	);
};

export default Header;
